import * as React from 'react';
import * as moment from 'moment';
import { IMicrositeRecipientCoachLogEntry } from '@nkr/models/index';
import { Button, Checkbox, FormControl, FormGroup, Label, Well } from 'react-bootstrap';

interface IProps {
    data: IMicrositeRecipientCoachLogEntry,
    onSave: (content: string, actionType: number, isPinned: boolean) => void,
    onCancel: () => void
}

interface IState {
    id: number,
    logDateTime: string,
    content: string,
    actionType: number,
    isPinned: boolean
    actionValid: boolean,
    contentValid: boolean,
}

class AddEditEntry extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            id: props.data != null ? props.data.id : 0,
            logDateTime: props.data != null ? props.data.logDateTime : moment().format('MM/DD/YYYY HH:mm'),
            content: props.data != null ? props.data.content : '',
            isPinned: props.data != null ? props.data.isPinned : false,
            actionType: props.data != null ? props.data.actionType : -1,
            actionValid: true,
            contentValid: true,
        };
    }

    handleUpdateContent = (e: React.ChangeEvent<FormControl & HTMLTextAreaElement>) => {
        this.setState({
            content: e.currentTarget.value
        });
    }

    handleActionTypeUpdate = (actionType: number) => {
        this.setState({
            actionType: actionType
        });
    }

    handleTogglePinned = () => {
        this.setState({
            isPinned: !this.state.isPinned
        });
    }

    handleSave = () => {
        if (this.isValid()) {
            let { content, actionType, isPinned } = this.state;
            this.props.onSave(content, actionType, isPinned);
        }
    }

    isValid = ():boolean => {
        const actionValid = this.state.actionType >= 0;
        const contentValid = this.state.content?.trim().length > 0
        this.setState({
            actionValid,
            contentValid,
        })
        return (actionValid && contentValid)
    }

    render = () => {
        return (
            <Well>
                <h4>{this.state.id == 0 ? 'New Entry' : 'Edit Entry'}</h4>
                <div><Label bsStyle='info'>{moment(this.state.logDateTime).format("MM-DD-YYYY h:mm a")}</Label></div><br />
                <FormGroup validationState={!this.state.actionValid ? 'error' : null}>
                    <FormControl
                        componentClass='select'
                        value={this.state.actionType}
                        onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.handleActionTypeUpdate(parseInt(e.currentTarget.value))}
                    >
                        <option value={-1}>- Select Action -</option>
                        <option value={0}>Called</option>
                        <option value={1}>Left Voicemail</option>
                        <option value={2}>Emailed</option>
                        <option value={3}>Texted</option>
                        <option value={99}>Other</option>
                    </FormControl>
                </FormGroup>
                <FormGroup validationState={!this.state.contentValid ? 'error' : null}>
                    <FormControl
                        componentClass='textarea'
                        rows={6}
                        style={{ resize: 'none', marginBottom: 5 }}
                        value={this.state.content}
                        onChange={this.handleUpdateContent}
                    />
                </FormGroup>
                <Checkbox checked={this.state.isPinned} onClick={this.handleTogglePinned}>Pinned</Checkbox>

                <div className='text-right'>
                    <Button bsStyle='primary' style={{ marginRight: 5 }} title='Save Entry' onClick={this.handleSave}>Save</Button>
                    <Button title='Cancel Entry' onClick={this.props.onCancel}>Cancel</Button>
                </div>
            </Well>
        );
    }
}

export default AddEditEntry;